document.addEventListener("DOMContentLoaded", function() {
  const buttons = document.querySelectorAll(".filter-btn");
  const grid = document.querySelector(".masonry-grid");

  // Initialize Isotope
  const iso = new Isotope(grid, {
    itemSelector: '.gallery-item',
    layoutMode: 'masonry',
    percentPosition: true,
    initLayout: false // new
  });

    // Wait for images, then layout & reveal
    imagesLoaded(grid, function() {
      iso.layout();
      grid.classList.add('masonry-grid-ready');
  });

  const lightbox = GLightbox({ selector: '.glightbox' });

  // Filtering
  buttons.forEach(button => {
    button.addEventListener("click", function() {    
      buttons.forEach(btn => btn.classList.remove("active"));
      this.classList.add("active");
      const filterValue = this.getAttribute("data-category");
      iso.arrange({ filter: filterValue === "all" ? '*' : `[data-category="${filterValue}"]` });
    });
  });


  // Then: wait for images and check URL hash
  imagesLoaded(grid, function () {
    iso.layout();
    grid.classList.add("masonry-grid-ready");

    // Check for hash filter after click handlers are ready
    const hash = window.location.hash;

    if (hash.startsWith("#filter-")) {
      const hashCategory = hash.replace("#filter-", "").toLowerCase();

      buttons.forEach((button) => {
        const btnCategory = button.getAttribute("data-category");
        const normalized = btnCategory.toLowerCase().replace(/\s+/g, "-");

        if (normalized === hashCategory) {
          button.click(); // now works because listener is already added
        }
      });
    }
  });
  

});